<script setup lang="ts">
import { CallHistory } from "~/types";
const isToday = (dateString: string): boolean => {
  const today = new Date();
  const date = new Date(dateString);
  return (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  );
};
const props = defineProps({
  callHistory: {
    type: Object as PropType<CallHistory>,
    required: true,
  },
});
</script>
<template>
  <audio controls >
    <source
      v-if="isToday(new Date(props.callHistory.created_at).toISOString())"
      :src="props.callHistory.audio_link"
      type="audio/wav"
    />
    <source
      :src="props.callHistory.audio_link.replace('.wav', '.flac')"
      type="audio/flac"
    />
    <source
      v-if="!isToday(new Date(props.callHistory.created_at).toISOString())"
      :src="props.callHistory.audio_link"
      type="audio/wav"
    />
    Your browser does not support the audio tag.
  </audio>
</template>
